<div class="container">
  <div class="header-wrapper">
  <div class="serviceHeader">
    <div class="row justify-content-between align-items-center">
      <div class="col-3">
      </div>
      <div class="col-1">
        <a tabindex="0" href="javascript:void(0)" class="cancel-text" (click)="routeBack()">Cancel</a>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-8 col-md-8 col-sm-9 col-xs-12">
        <div class="serviceTitle fontUltr style2">{{authoringContentData?.changeService?.changeServiceTxt}}</div>
        <div class="lineNo fontHalb style5">{{authoringContentData?.changeService?.lineTxt}}{{subscribersData?.msisdn | msisdn}}</div>
        <div class="serviceUserName">{{lineDetails?.lineIdentifier?.udf1}}</div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-3 col-xs-6">
        <div class="servicePlan fontHalb style6" ngbTooltip="{{subscribersData?.subscriber?.subscriberInfo?.pricePlanDescription}}">{{subscribersData?.subscriber?.subscriberInfo?.pricePlanDescription}}</div>
        <div class="servicePlanLabel">{{authoringContentData?.changeService?.planTxt}}</div>
      </div>
    </div>
  </div>


  <div class="row col-lg-12 col-md-12 col-xs-12">
    <div class="heading chooseServiceHeading customize-service style4">
      {{authoringContentData?.changeService?.customizeSearchTxt}}
    </div>
  </div>
  <div class="search-filters">
    <div *ngIf="!showSearch" class="row">
      <div class="col-sm-3 col-3 div-state">
        <mat-form-field class="filterWidth">
          <mat-select placeholder="{{this.groupType}}" (selectionChange)="filterServices()" [(ngModel)]="this.groupType">
            <mat-option *ngFor="let service of allTypes" [value]="service">
              {{service}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>


      <div class="col-sm-3 col-3 div-state">
        <mat-form-field class="filterWidth">
          <mat-select placeholder="{{this.serviceType}}" (selectionChange)="filterServices()" [(ngModel)]="this.serviceType">
            <mat-option *ngFor="let service of allServices" [value]="service">
              {{service}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <a (click)="showSearchOption()" class="row ml-auto mr-3 search-text" href="javascript:void(0)" tabindex="0">
        <div class ="float-right">
          <img class="fa fa-search magenta btn-search-icon" src="/assets/tfb-acctmgmt/images/icons/search.png" placeholder="Search" alt="">
          <span>{{authoringContentData?.changeService?.searchTxt}}</span>
        </div>
      </a>
    </div>
    <div class="col-lg-12 col-md-12 col-xs-12 searchbarMargin" *ngIf="showSearch">
      <input type="text" [(ngModel)]="searchText" placeholder="Search by service name" name="searchterm" id="tmobilelisting-search"
      class="tmobilelisting-search" autocomplete="off" maxlength="30" tabindex="0">
      <em class="fa fa-icon-size fa-search search-icon pull-left"></em>
      <a class="fa fa-icon-size fa-times close-icon pull-right" (click)="hideSearch()" href="javascript:void(0)" tabindex="0"></a>
    </div>
  </div>
</div>
  <div class="borderLine"></div>


  <div *ngFor="let type of types">
    <div *ngIf="getServicesLength(type, false)>zero">
      <div *ngFor="let service of servicesListForRender | serviceFilter : type | searchPipe : searchText | slice : 0 :serviceInfo[type]?.showCount; let i=index">
        <div class="fontUltr6 top-padding" *ngIf="i==zero">{{type}}</div>
        <div [ngClass]="{'selected':service.isSelected}" [attr.Soc]="service.soc"
          class="row col-12 container BG-Due-now-Copy-3 width1010 pad-right0">
          <mat-checkbox class="padding" [disabled]="isDisabled(service)" [ngClass]="{'disable-link': isDisabled(service)}"
            [(ngModel)]="service.isSelected" (change)="checkBoxClicked(service)"></mat-checkbox>
          <label class="col-lg-10 col-md-6 col-4 serviceName">{{service.name ? service.name : service.description}}</label>
          <label class="col-lg-1 col-md-4 col-12 servicePrice">{{service.price && service.price!== '0.0' ? (service.price | currency) +'/mo.'
            : 'Free'}}</label>
          <div class="col-md-8 col-lg-11 col-4 left-padding additionalDesc"
            innerHTML="{{service.additionalDescription ? service.additionalDescription : '-'}}"></div>
          <div class="col-11 row left-padding topSpace" *ngIf="currentServArray.indexOf(service.soc) > -1">
            <span class="icon-padding-left">
              <img src="/assets/tfb-acctmgmt/images/icons/greenvalidator.png" class="greenTick" alt="">
            </span>
            <div class="col-10 currentServc" *ngIf="isDisabled(service)">{{authoringContentData?.changeService?.currServiceProductLevelText}}</div>
            <div class="col-10 currentServc" *ngIf="!isDisabled(service)">{{authoringContentData?.changeService?.currServiceText}}</div>
          </div>
          <div class="col-11 row left-padding topSpace" *ngIf="service.currentlyConflictingWith.length>0 && !service.currentService">
            <span class="icon-padding-left">
              <img src="/assets/tfb-acctmgmt/images/invalidicon.png" class="redWarning" alt="">
            </span>
            <div class="col-10 conflictServc">{{authoringContentData?.changeService?.serviceConflictText}}{{' '}}<span
                *ngFor="let soc of service.currentlyConflictingWith">{{getNameOfSoc(soc)}}{{','}}</span>{{'
              '}}{{authoringContentData?.changeService?.previousSelectedText}}</div>
          </div>
        </div>

      </div>
      <a href="javascript:void(0)" class="moreStyle" *ngIf="!serviceInfo[type]?.isExpanded && serviceInfo[type]?.maxCount>two" (click)="updateData(type)" aria-controls="slider" tabindex="0">
        <div>
          {{authoringContentData?.changeService?.viewMoreTxt}} {{type.toLowerCase()}} {{authoringContentData?.changeService?.servicesTxt}} ({{serviceInfo[type]?.maxCount - two}})
        </div>
      </a>
    </div>

  </div>
  <div *ngIf="servicesFetched && (servicesListForRender?.length==zero || getServicesLength(searchText, true)==zero)" class="no-results text-center">{{authoringContentData?.changeService?.noResultFoundTxt}}</div>


</div>
<app-changeservices-sticky-footer [isServiceChanged]="isEdited" [previousServicesTotal]="previousServicesTotal" [currentServicesTotal]="currentServicesTotal"
  [subscriberData]="subscriberData" [servicesList]="servicesList" [currentSelectedServices]="currentSelectedServices"></app-changeservices-sticky-footer>

<!-- Technical Error Modal -->
<ng-template #promoError class="modal fade in" let-c="close" let-d="dismiss">
  <div class="promoTechErr">
  <div class="modal-header justify-content-start">
    <img src="/assets/tfb-acctmgmt/images/icons/error.svg" class="m-r-15 errorIcon" alt="">
    <h4 class="modal-title mt-0" id="modal-basic-title">{{authoringContentData?.militaryTechnicalError?.errModalTitle}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="manageLineService.close()">
     <span> <img src="/assets/tfb-acctmgmt/images/icons/close-icon.png" alt=""></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row m-0">
      <div class="addGroup-label">
        <p class="errBodyTxt">{{authoringContentData?.militaryTechnicalError?.errMessageBodyTxt}}</p>
      </div>
    </div>
  </div>
</div>
</ng-template>
